import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { SrdsClientDetailView } from '../components/views/srdsDashboardView'

export default function SrdsClient() {
    return (
        <div className="srdsClient">
            <Sidebar />
            <MainView><SrdsClientDetailView /></MainView>
        </div>
    )
}
